import _toConsumableArray from "/home/runner/work/trt-website-ua/trt-website-ua/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/trt-website-ua/trt-website-ua/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/trt-website-ua/trt-website-ua/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/trt-website-ua/trt-website-ua/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["client", "skip"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
import * as React from 'react';
import * as prismicH from '@prismicio/helpers';
import * as prismicR from '@prismicio/richtext';
import { Element } from '@prismicio/richtext';
export { Element } from '@prismicio/richtext';
var PrismicContext = React.createContext({});

var PrismicProvider = function PrismicProvider(_ref) {
  var client = _ref.client,
      linkResolver = _ref.linkResolver,
      richTextComponents = _ref.richTextComponents,
      internalLinkComponent = _ref.internalLinkComponent,
      externalLinkComponent = _ref.externalLinkComponent,
      children = _ref.children;
  var value = React.useMemo(function () {
    return {
      client: client,
      linkResolver: linkResolver,
      richTextComponents: richTextComponents,
      internalLinkComponent: internalLinkComponent,
      externalLinkComponent: externalLinkComponent
    };
  }, [client, linkResolver, richTextComponents, internalLinkComponent, externalLinkComponent]);
  return /* @__PURE__ */React.createElement(PrismicContext.Provider, {
    value: value
  }, children);
};

var usePrismicContext = function usePrismicContext() {
  return React.useContext(PrismicContext) || {};
};

if (typeof process === "undefined") {
  globalThis.process = {
    env: {}
  };
}

var __PRODUCTION__ = process.env.NODE_ENV === "production";

var prefix = "Invariant failed";

function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (__PRODUCTION__) {
    throw new Error(prefix);
  }

  throw new Error("".concat(prefix, ": ").concat(message || ""));
}

var usePrismicClient = function usePrismicClient(explicitClient) {
  var context = usePrismicContext();
  var client = explicitClient || (context == null ? void 0 : context.client);
  invariant(client, "A @prismicio/client is required to query documents. Provide a client to the hook or to a <PrismicProvider> higher in your component tree.");
  return client;
};

var isInternalURL = function isInternalURL(url) {
  var isInternal = /^(\/(?!\/)|#)/.test(url);
  var isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};

var defaultInternalComponent = "a";
var defaultExternalComponent = "a";

var PrismicLink = function PrismicLink(props) {
  var context = usePrismicContext();
  var linkResolver = props.linkResolver || context.linkResolver;
  var href;

  if ("href" in props) {
    href = props.href;
  } else if ("document" in props && props.document) {
    href = prismicH.asLink(props.document, linkResolver);
  } else if ("field" in props && props.field) {
    href = prismicH.asLink(props.field, linkResolver);
  }

  var target = props.target || "field" in props && props.field && "target" in props.field && props.field.target || void 0;
  var rel = props.rel || (target === "_blank" ? "noopener noreferrer" : void 0);
  var InternalComponent = props.internalComponent || context.internalLinkComponent || defaultInternalComponent;
  var ExternalComponent = props.externalComponent || context.externalLinkComponent || defaultExternalComponent;
  var isInternal = href && isInternalURL(href);
  var Component = isInternal ? InternalComponent : ExternalComponent;
  var passthroughProps = Object.assign({}, props);
  delete passthroughProps.linkResolver;
  delete passthroughProps.internalComponent;
  delete passthroughProps.externalComponent;
  delete passthroughProps.rel;
  delete passthroughProps.target;

  if ("field" in passthroughProps) {
    delete passthroughProps.field;
  } else if ("document" in passthroughProps) {
    delete passthroughProps.document;
  } else if ("href" in passthroughProps) {
    delete passthroughProps.href;
  }

  return href ? /* @__PURE__ */React.createElement(Component, _objectSpread(_objectSpread({}, passthroughProps), {}, {
    href: href,
    target: target,
    rel: rel
  })) : null;
};

var PrismicText = function PrismicText(props) {
  return React.useMemo(function () {
    if (props.field) {
      var text = prismicH.asText(props.field, props.separator);
      return /* @__PURE__ */React.createElement(React.Fragment, null, text);
    } else {
      return null;
    }
  }, [props.field, props.separator]);
};

var createDefaultSerializer = function createDefaultSerializer(args) {
  return prismicR.wrapMapSerializer({
    heading1: function heading1(_ref2) {
      var children = _ref2.children,
          key = _ref2.key;
      return /* @__PURE__ */React.createElement("h1", {
        key: key
      }, children);
    },
    heading2: function heading2(_ref3) {
      var children = _ref3.children,
          key = _ref3.key;
      return /* @__PURE__ */React.createElement("h2", {
        key: key
      }, children);
    },
    heading3: function heading3(_ref4) {
      var children = _ref4.children,
          key = _ref4.key;
      return /* @__PURE__ */React.createElement("h3", {
        key: key
      }, children);
    },
    heading4: function heading4(_ref5) {
      var children = _ref5.children,
          key = _ref5.key;
      return /* @__PURE__ */React.createElement("h4", {
        key: key
      }, children);
    },
    heading5: function heading5(_ref6) {
      var children = _ref6.children,
          key = _ref6.key;
      return /* @__PURE__ */React.createElement("h5", {
        key: key
      }, children);
    },
    heading6: function heading6(_ref7) {
      var children = _ref7.children,
          key = _ref7.key;
      return /* @__PURE__ */React.createElement("h6", {
        key: key
      }, children);
    },
    paragraph: function paragraph(_ref8) {
      var children = _ref8.children,
          key = _ref8.key;
      return /* @__PURE__ */React.createElement("p", {
        key: key
      }, children);
    },
    preformatted: function preformatted(_ref9) {
      var node = _ref9.node,
          key = _ref9.key;
      return /* @__PURE__ */React.createElement("pre", {
        key: key
      }, node.text);
    },
    strong: function strong(_ref10) {
      var children = _ref10.children,
          key = _ref10.key;
      return /* @__PURE__ */React.createElement("strong", {
        key: key
      }, children);
    },
    em: function em(_ref11) {
      var children = _ref11.children,
          key = _ref11.key;
      return /* @__PURE__ */React.createElement("em", {
        key: key
      }, children);
    },
    listItem: function listItem(_ref12) {
      var children = _ref12.children,
          key = _ref12.key;
      return /* @__PURE__ */React.createElement("li", {
        key: key
      }, children);
    },
    oListItem: function oListItem(_ref13) {
      var children = _ref13.children,
          key = _ref13.key;
      return /* @__PURE__ */React.createElement("li", {
        key: key
      }, children);
    },
    list: function list(_ref14) {
      var children = _ref14.children,
          key = _ref14.key;
      return /* @__PURE__ */React.createElement("ul", {
        key: key
      }, children);
    },
    oList: function oList(_ref15) {
      var children = _ref15.children,
          key = _ref15.key;
      return /* @__PURE__ */React.createElement("ol", {
        key: key
      }, children);
    },
    image: function image(_ref16) {
      var node = _ref16.node,
          key = _ref16.key;

      var _a;

      var img = /* @__PURE__ */React.createElement("img", {
        src: node.url,
        alt: (_a = node.alt) != null ? _a : void 0,
        "data-copyright": node.copyright ? node.copyright : void 0
      });
      return /* @__PURE__ */React.createElement("p", {
        key: key,
        className: "block-img"
      }, node.linkTo ? /* @__PURE__ */React.createElement(PrismicLink, {
        linkResolver: args.linkResolver,
        internalComponent: args.internalLinkComponent,
        externalComponent: args.externalLinkComponent,
        field: node.linkTo
      }, img) : img);
    },
    embed: function embed(_ref17) {
      var node = _ref17.node,
          key = _ref17.key;

      var _a;

      return /* @__PURE__ */React.createElement("div", {
        key: key,
        "data-oembed": node.oembed.embed_url,
        "data-oembed-type": node.oembed.type,
        "data-oembed-provider": node.oembed.provider_name,
        dangerouslySetInnerHTML: {
          __html: (_a = node.oembed.html) != null ? _a : ""
        }
      });
    },
    hyperlink: function hyperlink(_ref18) {
      var node = _ref18.node,
          children = _ref18.children,
          key = _ref18.key;
      return /* @__PURE__ */React.createElement(PrismicLink, {
        key: key,
        field: node.data,
        linkResolver: args.linkResolver,
        internalComponent: args.internalLinkComponent,
        externalComponent: args.externalLinkComponent
      }, children);
    },
    label: function label(_ref19) {
      var node = _ref19.node,
          children = _ref19.children,
          key = _ref19.key;
      return /* @__PURE__ */React.createElement("span", {
        key: key,
        className: node.data.label
      }, children);
    },
    span: function span(_ref20) {
      var text = _ref20.text,
          key = _ref20.key;
      var result = [];
      var i = 0;

      var _iterator = _createForOfIteratorHelper(text.split("\n")),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;

          if (i > 0) {
            result.push( /* @__PURE__ */React.createElement("br", {
              key: "".concat(i, "__break")
            }));
          }

          result.push( /* @__PURE__ */React.createElement(React.Fragment, {
            key: "".concat(i, "__line")
          }, line));
          i++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return /* @__PURE__ */React.createElement(React.Fragment, {
        key: key
      }, result);
    }
  });
};

var PrismicRichText = function PrismicRichText(props) {
  var context = usePrismicContext();
  return React.useMemo(function () {
    if (!props.field) {
      return null;
    } else {
      var linkResolver = props.linkResolver || context.linkResolver;
      var defaultSerializer = createDefaultSerializer({
        linkResolver: linkResolver,
        internalLinkComponent: props.internalLinkComponent,
        externalLinkComponent: props.externalLinkComponent
      });
      var serializer = prismicR.composeSerializers(typeof props.components === "object" ? prismicR.wrapMapSerializer(props.components) : props.components, typeof context.richTextComponents === "object" ? prismicR.wrapMapSerializer(context.richTextComponents) : context.richTextComponents, defaultSerializer);
      var serialized = prismicR.serialize(props.field, serializer);
      return /* @__PURE__ */React.createElement(React.Fragment, null, serialized);
    }
  }, [props.field, props.internalLinkComponent, props.externalLinkComponent, props.components, props.linkResolver, context.linkResolver, context.richTextComponents]);
};

var TODOSliceComponent = __PRODUCTION__ ? function () {
  return null;
} : function (_ref21) {
  var slice = _ref21.slice;
  React.useEffect(function () {
    console.warn("[SliceZone] Could not find a component for Slice type \"".concat(slice.slice_type, "\""), slice);
  }, [slice]);
  return /* @__PURE__ */React.createElement("section", {
    "data-slice-zone-todo-component": "",
    "data-slice-type": slice.slice_type
  }, "Could not find a component for Slice type \u201C", slice.slice_type, "\u201D");
};

var SliceZone = function SliceZone(_ref22) {
  var _ref22$slices = _ref22.slices,
      slices = _ref22$slices === void 0 ? [] : _ref22$slices,
      _ref22$components = _ref22.components,
      components = _ref22$components === void 0 ? {} : _ref22$components,
      resolver = _ref22.resolver,
      _ref22$defaultCompone = _ref22.defaultComponent,
      defaultComponent = _ref22$defaultCompone === void 0 ? TODOSliceComponent : _ref22$defaultCompone,
      _ref22$context = _ref22.context,
      context = _ref22$context === void 0 ? {} : _ref22$context;
  var renderedSlices = React.useMemo(function () {
    return slices.map(function (slice, index) {
      var Comp = components[slice.slice_type] || defaultComponent;

      if (resolver) {
        var resolvedComp = resolver({
          slice: slice,
          sliceName: slice.slice_type,
          i: index
        });

        if (resolvedComp) {
          Comp = resolvedComp;
        }
      }

      var key = "".concat(index, "-").concat(JSON.stringify(slice));
      return /* @__PURE__ */React.createElement(Comp, {
        key: key,
        slice: slice,
        index: index,
        slices: slices,
        context: context
      });
    });
  }, [components, context, defaultComponent, slices]);
  return /* @__PURE__ */React.createElement(React.Fragment, null, renderedSlices);
};

var PrismicToolbar = function PrismicToolbar(_ref23) {
  var repositoryName = _ref23.repositoryName,
      _ref23$type = _ref23.type,
      type = _ref23$type === void 0 ? "new" : _ref23$type;
  var src = "https://static.cdn.prismic.io/prismic.js?repo=".concat(repositoryName).concat(type === "new" ? "&new=true" : "");
  React.useEffect(function () {
    var existingScript = document.querySelector("script[src=\"".concat(src, "\"]"));

    if (!existingScript) {
      var script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.dataset.prismicToolbar = "";
      script.dataset.repositoryName = repositoryName;
      script.dataset.type = type;
      document.body.appendChild(script);
    }
  }, [repositoryName, type]);
  return null;
};

var reducer = function reducer(state, action) {
  switch (action[0]) {
    case "start":
      {
        return {
          state: "loading"
        };
      }

    case "succeed":
      {
        return {
          state: "loaded",
          data: action[1]
        };
      }

    case "fail":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          state: "failed",
          error: action[1]
        });
      }
  }
};

var initialState = {
  state: "idle"
};

var isParams = function isParams(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};

var useStatefulPrismicClientMethod = function useStatefulPrismicClientMethod(methodName, args, explicitClient) {
  var lastArg = args[args.length - 1];

  var _ref24 = isParams(lastArg) ? lastArg : {},
      lastArgExplicitClient = _ref24.client,
      skip = _ref24.skip,
      params = _objectWithoutProperties(_ref24, _excluded);

  var argsWithoutParams = isParams(lastArg) ? args.slice(0, -1) : args;
  var client = usePrismicClient(explicitClient || lastArgExplicitClient);

  var _React$useReducer = React.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  React.useEffect(function () {
    if (!skip) {
      var _client$methodName;

      {
        dispatch(["start"]);
      }

      (_client$methodName = client[methodName]).call.apply(_client$methodName, [client].concat(_toConsumableArray(argsWithoutParams), [params])).then(function (result) {
        {
          dispatch(["succeed", result]);
        }
      }).catch(function (error) {
        {
          dispatch(["fail", error]);
        }
      });
    }
  }, [client, methodName, skip, JSON.stringify(argsWithoutParams), JSON.stringify(params)]);
  return React.useMemo(function () {
    return [state.data, {
      state: state.state,
      error: state.error
    }];
  }, [state]);
};

var usePrismicPreviewResolver = function usePrismicPreviewResolver() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = usePrismicContext();
  var linkResolver = args.linkResolver || context.linkResolver;
  var result = useStatefulPrismicClientMethod("resolvePreviewURL", [{
    linkResolver: linkResolver,
    defaultURL: args.defaultURL || "/",
    previewToken: args.previewToken,
    documentID: args.documentID
  }], args.client);

  var _result = _slicedToArray(result, 1),
      resolvedURL = _result[0];

  var navigate = args.navigate;
  React.useEffect(function () {
    if (resolvedURL && navigate) {
      navigate(resolvedURL);
    }
  }, [resolvedURL, navigate]);
  return result;
};

var usePrismicDocuments = function usePrismicDocuments() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return useStatefulPrismicClientMethod("get", args);
};

var useFirstPrismicDocument = function useFirstPrismicDocument() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return useStatefulPrismicClientMethod("getFirst", args);
};

var useAllPrismicDocumentsDangerously = function useAllPrismicDocumentsDangerously() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return useStatefulPrismicClientMethod("dangerouslyGetAll", args);
};

var usePrismicDocumentByID = function usePrismicDocumentByID() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return useStatefulPrismicClientMethod("getByID", args);
};

var usePrismicDocumentsByIDs = function usePrismicDocumentsByIDs() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return useStatefulPrismicClientMethod("getByIDs", args);
};

var useAllPrismicDocumentsByIDs = function useAllPrismicDocumentsByIDs() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  return useStatefulPrismicClientMethod("getAllByIDs", args);
};

var usePrismicDocumentByUID = function usePrismicDocumentByUID() {
  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  return useStatefulPrismicClientMethod("getByUID", args);
};

var usePrismicDocumentsByUIDs = function usePrismicDocumentsByUIDs() {
  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  return useStatefulPrismicClientMethod("getByUIDs", args);
};

var useAllPrismicDocumentsByUIDs = function useAllPrismicDocumentsByUIDs() {
  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  return useStatefulPrismicClientMethod("getAllByUIDs", args);
};

var useSinglePrismicDocument = function useSinglePrismicDocument() {
  for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    args[_key10] = arguments[_key10];
  }

  return useStatefulPrismicClientMethod("getSingle", args);
};

var usePrismicDocumentsByType = function usePrismicDocumentsByType() {
  for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }

  return useStatefulPrismicClientMethod("getByType", args);
};

var useAllPrismicDocumentsByType = function useAllPrismicDocumentsByType() {
  for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return useStatefulPrismicClientMethod("getAllByType", args);
};

var usePrismicDocumentsByTag = function usePrismicDocumentsByTag() {
  for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }

  return useStatefulPrismicClientMethod("getByTag", args);
};

var useAllPrismicDocumentsByTag = function useAllPrismicDocumentsByTag() {
  for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }

  return useStatefulPrismicClientMethod("getAllByTag", args);
};

var usePrismicDocumentsBySomeTags = function usePrismicDocumentsBySomeTags() {
  for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }

  return useStatefulPrismicClientMethod("getBySomeTags", args);
};

var useAllPrismicDocumentsBySomeTags = function useAllPrismicDocumentsBySomeTags() {
  for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    args[_key16] = arguments[_key16];
  }

  return useStatefulPrismicClientMethod("getAllBySomeTags", args);
};

var usePrismicDocumentsByEveryTag = function usePrismicDocumentsByEveryTag() {
  for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    args[_key17] = arguments[_key17];
  }

  return useStatefulPrismicClientMethod("getByEveryTag", args);
};

var useAllPrismicDocumentsByEveryTag = function useAllPrismicDocumentsByEveryTag() {
  for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }

  return useStatefulPrismicClientMethod("getAllByEveryTag", args);
};

var Elements = Element;
export { Elements, PrismicLink, PrismicProvider, PrismicRichText, PrismicText, PrismicToolbar, SliceZone, TODOSliceComponent, useAllPrismicDocumentsByEveryTag, useAllPrismicDocumentsByIDs, useAllPrismicDocumentsBySomeTags, useAllPrismicDocumentsByTag, useAllPrismicDocumentsByType, useAllPrismicDocumentsByUIDs, useAllPrismicDocumentsDangerously, useFirstPrismicDocument, usePrismicClient, usePrismicContext, usePrismicDocumentByID, usePrismicDocumentByUID, usePrismicDocuments, usePrismicDocumentsByEveryTag, usePrismicDocumentsByIDs, usePrismicDocumentsBySomeTags, usePrismicDocumentsByTag, usePrismicDocumentsByType, usePrismicDocumentsByUIDs, usePrismicPreviewResolver, useSinglePrismicDocument };